import { IconButton, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useVrsTranslationState } from "../../../context/AppContext/AppContext";
import { styled } from "@mui/material/styles";

const InfoButton = styled(IconButton)(({ theme }) => ({
  marginLeft: -theme.spacing(0.5)
}));

const InfoTooltip = ({
  textId,
  text,
  placement,
  extraClass,
}: {
  textId?: string;
  text?: string;
  placement?: any;
  extraClass?: string;
}) => {
  const { _T } = useVrsTranslationState();
  return (
    <Tooltip
      title={text ? text : textId ? _T(textId) : ""}
      placement={placement || "top-start"}
    >
      <InfoButton
        aria-label={text ? text : textId ? _T(textId) : ""}
        className={extraClass}
      >
        <InfoIcon data-testid="InfoIcon"/>
      </InfoButton>
    </Tooltip>
  );
};

export { InfoTooltip };
